import TabButton from "@/components/buttons/tab-button"
import SummaryContent from "./summary-content"
import { langStore } from "@/stores/lang-store"
import { useSearchParams } from "react-router-dom"
import { Fragment } from "react"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { RESOURCES } from "@/constants/resource-const"
import Wrapper from "@/components/wrapper"

const SummaryView = ({ className = "" }) => {
  const { lang } = langStore()
  const { pickApt } = aptSearchStore()

  const [searchParams, setSearchParams] = useSearchParams()
  const resource = searchParams.get("resource") ?? "water"

  const changeResource = (newResource) => {
    const next = new URLSearchParams(searchParams)

    next.set("resource", newResource)

    setSearchParams(next)
  }

  return (
    <Wrapper.shadow className={className}>
      <div className="hidden md:block">
        <Wrapper.tab>
          {RESOURCES.map((r) => {
            const active = resource === r.id

            if (pickApt?.heat_type === 1 && ["hotwater", "hot"].includes(r.id)) {
              return <Fragment key={r.id} />
            }

            return (
              <TabButton key={r.id} onClick={() => changeResource(r.id)} isActive={active}>
                {r.label[lang]}
              </TabButton>
            )
          })}
        </Wrapper.tab>
      </div>

      <SummaryContent />
    </Wrapper.shadow>
  )
}

export default SummaryView
